import React, { useEffect } from 'react';
import { FiAlertTriangle, FiCheckCircle, FiXCircle, FiInfo } from 'react-icons/fi';
import styles from './CustomAlert.module.css';

const icons = {
    success: FiCheckCircle,
    error: FiXCircle,
    warning: FiAlertTriangle,
    info: FiInfo,
    question: FiAlertTriangle,
};

const CustomAlert = ({ show, type, title, text, showCancelButton, onConfirm, onCancel, autoClose }) => {
    
    const IconComponent = icons[type] || FiInfo;
    
    const handleConfirm = () => {
        if (onConfirm) onConfirm();
    };

    const handleCancel = () => {
        // Esta função é a principal responsável por fechar o alerta
        if (onCancel) onCancel();
    };
    
    // CORREÇÃO: useEffect deve ser chamado antes do return condicional.
    // Adicionamos 'handleCancel' à lista de dependências para resolver o warning.
    useEffect(() => {
        if (show && autoClose && type !== 'question') {
            const timer = setTimeout(() => {
                // Chama a função de cancelamento/fechamento
                handleCancel(); 
            }, autoClose); 
            
            return () => clearTimeout(timer);
        }
    }, [show, autoClose, type, handleCancel]); // <-- handleCancel adicionado aqui

    // CORREÇÃO: O retorno condicional (early return) deve vir APÓS as chamadas de Hooks.
    if (!show) return null;

    return (
        <div className={styles.alertBackdrop}>
            <div className={`${styles.alertBox} ${styles[type]}`}>
                
                <div className={styles.alertHeader}>
                    <IconComponent className={styles.alertIcon} />
                    <h3 className={styles.alertTitle}>{title}</h3>
                </div>

                <p className={styles.alertText}>{text}</p>
                
                <div className={styles.alertActions}>
                    {showCancelButton && (
                        <button 
                            className={`${styles.btnAction} ${styles.btnCancel}`} 
                            onClick={handleCancel}
                        >
                            Cancelar
                        </button>
                    )}
                    <button 
                        className={`${styles.btnAction} ${styles.btnConfirm}`} 
                        onClick={handleConfirm}
                    >
                        {type === 'question' ? 'Sim, Deletar' : 'Entendi'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CustomAlert;